import React, { Component } from 'react'
import { connect } from 'react-redux'
import Waypoint from 'react-waypoint'

import * as actions from '../../../state/actions/anchors'

class Anchor extends Component{

	handleChange = (props) => {
		const { currentPosition} = props
		const { anchorUpdate, attrs } = this.props

		currentPosition === "above" ? anchorUpdate(attrs.slug, true) : anchorUpdate(attrs.slug, false)
	}

	render(){
		const {attrs} = this.props
		
		// Validation des props
		if (!attrs || !attrs.slug) {
			return (
				<div role="alert" aria-live="polite" className="anchor-error">
					Configuration de l'ancre invalide
				</div>
			)
		}

		const title = attrs.linkName || attrs.title || 'Section sans titre'
		
		return(
			<section 
				className="anchor-section"
				role="region"
				aria-label={`Section ${title}`}
				aria-labelledby={attrs.slug}
			>
				<div className="anchor-point" aria-hidden="true">
					<Waypoint onEnter={this.handleChange} onLeave={this.handleChange} />
				</div>
				<h2 id={attrs.slug} className="anchor-title">
					{title}
				</h2>
			</section>
		)
	}
}

export default connect(null, actions)(Anchor)
